import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { LinkData } from '../../../bdo/models/LinkData';
import { ReBaseData } from '../../utils/re-base-data';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'bdo-coop-teaser',
    templateUrl: './coop-teaser.component.html',
    styleUrls: ['./coop-teaser.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CoopTeaserComponent {
  @Input() title: string;
  @Input() iconSrc?: string; // Either set a local iconSrc
  @Input() externalIconSrc?: string; // or an external img link
  @Input() linkData: LinkData[];
  protected reBaseData = ReBaseData;

  constructor(
    public domSanitizer: DomSanitizer
  ) { }

}
